// useExporterName — nom complet de l'utilisateur connecté (pour le pied de page PDF)
import { useContext } from 'react';
import { AuthContext } from '../constants';

export default function useExporterName() {
    const ctx = useContext(AuthContext);
    const u = ctx?.currentUser;
    if (!u) return '';
    return `${u.firstName || ''} ${u.lastName || ''}`.trim();
}
